var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgUploadIconB = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.602 17.856v4.302c0 .652.245 1.278.683 1.739.438.461 1.031.72 1.65.72h14c.619 0 1.212-.259 1.65-.72a2.527 2.527 0 0 0 .683-1.739v-4.302m-9.332-.306V3.617m0 0L9.602 8.941m5.334-5.324 5.333 5.324",
    stroke: "#000",
    strokeWidth: 2.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUploadIconB, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/UploadIconB.c1a82bcf.svg";
export { ForwardRef as ReactComponent };